import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CreateContactRequest, HttpResponse } from "@/types";

export function useCreateContact() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      createContactRequest,
    }: {
      createContactRequest: CreateContactRequest;
    }) => {
      const path = `companies/${currentCompanyId}/contact`;
      const res = await httpClient.post<
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        void,
        HttpResponse<void>,
        CreateContactRequest
      >(path, createContactRequest);

      return res.data;
    },
  });

  return mutation;
}
